import { makeStyles } from '@mui/styles'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeStyles((theme: any) => ({
    root: {
        flexGrow: 1,
        overflow: 'visible',
    },

    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        borderRadius: '2px',
        [theme.breakpoints.down('sm')]: {
            margin: '0px',
        },
    },

    gridItemsContainerLeft: {
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            maxWidth: 'inherit',
        },
    },

    gridItemsContainerRight: {
        textAlign: 'right',
        overflow: 'visible',
        [theme.breakpoints.down('sm')]: {
            maxWidth: 'inherit',
        },
    },

    gridItemsDiv: {
        width: '90%',
        display: 'inline-grid',
        [theme.breakpoints.down('sm')]: {
            minWidth: '240px',
            width: '100%',
        },
    },

    topCard: {
        [theme.breakpoints.down('sm')]: {
            paddingBottom: '0px !important',
        },
    },

    bottomCard: {
        [theme.breakpoints.down('sm')]: {
            paddingTop: '0px !important',
        },
    },

    gridItemContent: {
        marginTop: '5px',
        marginBottom: '1rem',
        width: '100%',
    },

    containerSaveBtn: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '20px',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'space-between',
        },
    },

    saveBtnStyle: {
        alignSelf: 'flex-end',
        borderRadius: '2px',
        margin: '5px',
        [theme.breakpoints.down('sm')]: {
            alignSelf: 'start',
        },
    },

    postalCode: {
        marginTop: '5px',
        marginBottom: '10px',
        width: '50%',
    },

    mailCard: {
        width: '100%',
        marginBottom: '1rem',
    },

    topCardForm: {
        paddingBottom: '16px',
        [theme.breakpoints.down('sm')]: {
            paddingBottom: '0px',
        },
    },

    topCardTitle: {
        marginBottom: '0px',
        fontWeight: 'bold',
        fontSize: '22px',
        color: theme.palette.textPrimaryColor.main,
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },

    EstablishmentHeader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '3rem',
        paddingBottom: '1rem',
        borderBottom: `1px solid ${theme.palette.lightGrey.half}`,
    },

    EstablishmentHeaderTab: {
        position: 'relative',
        fontWeight: 900,
        opacity: 0.6,
    },

    EstablishmentHeaderActiveTab: {
        opacity: 1,
        '&::before': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            right: 0,
            left: 0,
            height: '3px',
            borderRadius: 100,
            background: theme.palette.typography.main,
        },
    },

    EstablishmentButtons: {
        marginTop: '5rem',
    },

    EstablishmentErrorText: {
        color: defaultPalette.red.main,
        fontSize: '1rem',
    },
}))
